module.exports = __webpack_public_path__ + "assets/expired-token.6d075fc4.svg";